<template>
  <div class="filter_frame">
    <div class="titleBar">
      依下方任一條件查詢<span v-if="subTitle">（{{ subTitle }}）</span>
    </div>
    <el-form ref="form" :inline="true" :model="selectedValue" label-position="left" label-width="80px" :rules="rule" :show-message="false" @submit.native.prevent>
      <el-form-item
        v-for="(fVal, fInd) in filterForm"
        :key="fInd"
        :label="fVal.label"
        :prop="fVal.name"
        :required="fVal.required"
        :class="{ 'item-content--center': fVal.alignCenter, 'item-content--wider': fVal.wider }"
      >
        <!-- 單選 下拉式選單 -->
        <el-select v-if="fVal.type == 'select'" v-model="selectedValue[fVal.name]" filterable :disabled="fVal.isDisable" :clearable="fVal.clearable" @change="(v)=>change(fInd, v)">
          <el-option v-for="(item) in fVal.options" :key="item.key || item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <!-- 多選 下拉式選單 -->
        <el-select
          v-if="fVal.type == 'multiselect'"
          v-model="selectedValue[fVal.name]"
          filterable
          multiple
          :disabled="fVal.isDisable"
        >
          <el-option
            v-for="item in fVal.options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <!-- 多選 有限 下拉式選單 -->
        <el-select
          v-if="fVal.type == 'multiselectLimit'"
          v-model="selectedValue[fVal.name]"
          filterable
          multiple
          :multiple-limit="fVal.limit"
          :disabled="fVal.isDisable"
        >
          <el-option
            v-for="item in fVal.options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <!-- 級聯選擇器 -->
        <el-cascader
          v-if="fVal.type == 'cascader'"
          v-model="selectedValue[fVal.name]"
          style="width: 100%"
          :options="fVal.options"
          :props="{ checkStrictly: true }"
          clearable
          :disabled="fVal.isDisable"
          @expand-change="changeSelect(fVal, $event)"
        />
        <!-- 戶別選擇，有虛擬戶 -->
        <el-button
          v-if="fVal.type == 'house'"
          round
          @click="householdSwitch = true"
        >
          {{ selectedValue[fVal.name] ? selectedValue[fVal.name].TabletNote : $t('Household.SelectHousehold') }}
        </el-button>
        <!-- 戶別選擇，無虛擬戶 -->
        <el-button
          v-if="fVal.type == 'houseNoVirtual'"
          round
          @click="$refs.householdFrame.openNotShowVirtual()"
        >
          {{ selectedValue[fVal.name] ? selectedValue[fVal.name].TabletNote : $t('Household.SelectHousehold') }}
        </el-button>        <!-- 日期 -->
        <!-- 日期 -->
        <el-date-picker
          v-if="fVal.type == 'date'"
          v-model="selectedValue[fVal.name]"
          value-format="yyyy-MM-dd"
          type="daterange"
          unlink-panels
          range-separator="至"
          start-placeholder="開始"
          end-placeholder="結束"
          :picker-options="generatePickerOptions(fVal.pickerOptions)"
          :clearable="pickerIsClearable(fVal.pickerOptions)"
        >
        </el-date-picker>
        <!-- 輸入框 -->
        <el-input
          v-if="fVal.type == 'input'"
          v-model="selectedValue[fVal.name]"
          :placeholder="fVal.placeholder || '請輸入' + fVal.label"
          :style="fVal.style || {}"
          :clearable="fVal.clearable"
          :maxlength="fVal.maxlength || ''"
        />
        <!-- 多選 -->
        <el-checkbox-group
          v-if="fVal.type == 'checkbox'"
          v-model="selectedValue[fVal.name]"
        >
          <el-checkbox
            v-for="item in fVal.options"
            :key="item"
            :label="item"
          >
            {{ item }}
          </el-checkbox>
        </el-checkbox-group>
        <!-- 單選＋日期 -->
        <!-- <el-form-item v-if="fVal.type == 'radioAndDate'" class="radioAndDate"/> -->
        <!-- 單選 -->
        <el-radio-group
          v-if="fVal.type == 'radio'"
          v-model="selectedValue[fVal.name]"
        >
          <el-radio
            v-for="item in fVal.options"
            :key="item.value"
            :label="item.value"
          >
            {{ item.label }}
          </el-radio>
        </el-radio-group>
        <!-- 單選＋日期 -->
        <el-form-item
          v-if="fVal.type == 'radioAndDate'"
          class="radioAndDate"
        >
          <el-radio-group v-model="selectedValue[fVal.name+'Radio']">
            <el-radio
              v-for="item in fVal.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-radio-group>
          <el-date-picker
            v-model="selectedValue[fVal.name+'Date']"
            value-format="yyyy-MM-dd"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="開始"
            end-placeholder="結束"
          />
        </el-form-item>
        <!-- 選擇月份 -->
        <el-form-item
          v-if="fVal.type == 'month'"
          class="month"
        >
          <el-date-picker
            v-model="selectedValue[fVal.name]"
            type="month"
            placeholder="選擇月份"
            value-format="yyyyMM"
          />
        </el-form-item>
        <!-- 選擇時間 -->
        <el-form-item v-if="fVal.type == 'time'">
          <el-time-select
            v-model="selectedValue[fVal.name1]"
            :placeholder="fVal.control.placeholder1"
            :picker-options="fVal.control.pickerOptions1"
            @change="timeSelect1(fVal)"
          />
          <span class="timeSelect">至</span>
          <el-time-select
            v-if="fVal.control.showEndTime"
            v-model="selectedValue[fVal.name2]"
            :placeholder="fVal.control.placeholder2"
            :picker-options="fVal.control.pickerOptions2"
            @change="timeSelect2(fVal)"
          />
        </el-form-item>
        <!-- 選擇日期+時間 -->
        <el-date-picker
          v-if="fVal.type == 'datetime'"
          v-model="selectedValue[fVal.name]"
          type="datetimerange"
          unlink-panels
          range-separator="至"
          start-placeholder="開始"
          end-placeholder="結束"
          format="yyyy-MM-dd HH:mm"
          :default-time="fVal.pickerOptions?.default?.time || []"
        />
        <template v-if="fVal.type == 'barcode'">
          <el-input
            v-model="selectedValue.SerialNum"
            class="barcode-input"
            :placeholder="fVal.placeholder || '請輸入' + fVal.label"
            :style="fVal.style || {}"
            :clearable="fVal.clearable"
            :maxlength="fVal.maxlength || ''"
          />
          <el-button round @click="readerGetCode('TransportCode')">
            {{ selectedValue.TransportCode ? selectedValue.TransportCode : '包裹條碼搜尋' }}
          </el-button>
        </template>
        <!-- 依日期/依月份 -->
        <template v-if="fVal.type === 'dateOrMonthPicker'">
          <div>
            <el-radio-group v-model="selectedValue[fVal.name+'Radio']" @change="onDateTypeChange(fVal.name)">
              <el-radio
                v-for="item in fVal.options"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </div>
          <el-date-picker
            v-show="selectedValue[fVal.name+'Radio']=== '1'"
            v-model="selectedValue[fVal.name+'Date']"
            :editable="false"
            :picker-options="datePickerOptions"
            type="daterange"
            :clearable="false"
            placeholder="選擇日期"
          />
          <el-date-picker
            v-show="selectedValue[fVal.name+'Radio'] === '2'"
            v-model="selectedValue[fVal.name+'Date']"
            type="monthrange"
            format="yyyy-MM"
            :picker-options="monthPickerOptions"
            :clearable="false"
            :editable="false"
            placeholder="選擇月份"
          />
        </template>
        <!-- 單周/單月 -->
        <template v-if="fVal.type === 'SingleWeekOrMonth'">
          <div>
            <el-radio-group v-model="selectedValue[fVal.name+'Radio']" @change="onDateTypeChange2(selectedValue[fVal.name+'Radio'], fVal.name)">
              <el-radio
                v-for="item in fVal.options"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </div>
          <el-date-picker
            v-show="selectedValue[fVal.name+'Radio'] === 1"
            v-model="selectedValue[fVal.name+'Date']"
            type="week"
            format="yyyy 第 WW 周"
            placeholder="選擇周"
            :picker-options="weekPickerOptions"
            :editable="false"
            :clearable="false"
          >
          </el-date-picker>
          <el-date-picker
            v-show="selectedValue[fVal.name+'Radio'] === 2"
            v-model="selectedValue[fVal.name+'Date']"
            type="month"
            placeholder="選擇月"
            :picker-options="monthPickerOptions"
            :editable="false"
            :clearable="false"
          >
          </el-date-picker>
        </template>
      </el-form-item>
    </el-form>
    <div class="controls">
      <el-button
        v-if="submitType === ''"
        id="searchButton"
        type="primary"
        icon="icon-search"
        round
        @click="onSearch"
      >
        查詢
      </el-button>
      <el-button
        v-if="submitType === 'export'"
        id="searchButton"
        type="primary"
        icon="icon-output"
        round
        @click="onSearch"
      >
        匯出
      </el-button>
      <el-button
        id="clearButton"
        round
        @click="onClear"
      >
        清除條件
      </el-button>
    </div>
    <hosuehold-frame
      v-if="houseSelectable"
      ref="householdFrame"
      :open.sync="householdSwitch"
      @select-household="selectedHousehold"
    />
    <ReadNFCBarcode ref="readNFCBarcode" />
  </div>
</template>
<script>
import householdFrame from '@/components/HouseholdFrame'
import ReadNFCBarcode from '@/components/ReadNFCBarcode'
export default {
  components: {
    'hosuehold-frame': householdFrame,
    ReadNFCBarcode
  },
  props: {
    filterForm: Array,
    submitType: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    autoSearch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedValue: {},
      householdSwitch: false,
      firstSelectDate: null,
      rule: {},
      pickerOptions: { // ['currentDay', 'currentWeek', 'currentMonth', 'currentYear', 'lastSevenDays', 'lastThirtyDays', 'lastThreeMonth', 'lastSixMonth']
        currentDay: {
          text: '本日',
          range: [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
        },
        currentWeek: {
          text: '本週',
          range: [dayjs().startOf('week').format('YYYY-MM-DD'), dayjs().endOf('week').format('YYYY-MM-DD')]
        },
        currentMonth: {
          text: '本月',
          range: [dayjs().startOf('month').format('YYYY-MM-DD'), dayjs().endOf('month').format('YYYY-MM-DD')]
        },
        currentYear: {
          text: '今年',
          range: [dayjs().startOf('year').format('YYYY-MM-DD'), dayjs().endOf('year').format('YYYY-MM-DD')]
        },
        lastSevenDays: {
          text: '近一周',
          range: [dayjs().add(-7, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
        },
        lastMonth: {
          text: '近一個月',
          range: [dayjs().add(-30, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
        },
        lastThreeMonth: {
          text: '近三個月',
          range: [dayjs().add(-90, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
        },
        lastSixMonth: {
          text: '近六個月',
          range: [dayjs().add(-180, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
        },
        lastYear: {
          text: '近一年',
          range: [dayjs().add(-364, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
        }
      }
    }
  },
  computed: {
    houseSelectable () {
      const isSelectable = this.filterForm.some(item => {
        console.log(item)
        // eslint-disable-next-line eqeqeq
        return item.type == 'house' || item.type == 'houseNoVirtual'
      })
      return isSelectable
    },
    datePickerOptions () {
      return {
        onPick: (date) => this.firstSelectDate = date,
        disabledDate: this.setDisabledDate
      }
    },
    weekPickerOptions () {
      return {
        onPick: (date) => this.firstSelectDate = date,
        disabledDate: this.setDisabledWeek
      }
    },
    monthPickerOptions () {
      return {
        onPick: (date) => this.firstSelectDate = date,
        disabledDate: this.setDisabledMonth
      }
    }
  },
  watch: {
    filterForm: {
      handler: function (newVal, oldVal) {
        this.initForm()
      },
      deep: true
    },
    selectedValue: {
      handler: function (newVal, oldVal) {
        this.$emit('onSelectedValueChange', newVal)
      },
      deep: true
    }
  },
  created () {
    this.filterForm.forEach(f => {
      if (f.type === 'checkbox') {
        this.$set(this.selectedValue, f.name, [])
      }
    })
  },
  mounted () {
    this.$nextTick(function () {
      if (this.filterForm && this.filterForm.length !== 0) {
        this.initForm()
      }
      if (this.autoSearch) this.onSearch(true)
    })
  },
  methods: {
    initForm () { // 已選擇項目帶入初始值
      this.filterForm.forEach(f => {
        console.log(f)
        if (f.rule) {
          this.rule[f.name] = f.rule
        }
        if (f.type === 'dateOrMonthPicker') {
          this.$set(this.selectedValue, f.name + 'Radio', f.value.radio)
          this.$set(this.selectedValue, f.name + 'Date', f.value.date)
        } else if (f.type === 'SingleWeekOrMonth') {
          this.$set(this.selectedValue, f.name + 'Radio', f.value.radio)
          this.$set(this.selectedValue, f.name + 'Date', f.value.date)
        } else if (f.value) {
          this.$set(this.selectedValue, f.name, f.value)
        }
      })
    },
    onSearch (isAutoSearch = false) { // 點擊查詢
      this.$refs.form.validate((valid, errMsg) => {
        if (!valid) {
          let errorMessage = ''
          Object.keys(errMsg).forEach(key => {
            errMsg[key].forEach(errObj => {
              let tempErrorMessage = errObj.message
              // 未填寫必須欄位的錯誤訊息
              if (errObj.message.includes('require')) {
                const name = errObj.field
                const errorItem = this.filterForm.filter(el => el.name === name)
                const label = errorItem[0].label
                tempErrorMessage = `請輸入${label}`
              }
              // 多個 errorMessage 則換行
              errorMessage += errorMessage ? '</br>' + tempErrorMessage : tempErrorMessage
            })
          })
          this.$alert(errorMessage, '', {
            type: 'warning',
            dangerouslyUseHTMLString: true,
            callback: action => {}
          }, () => {})
        } else {
          document.getElementById('searchButton').blur()
          Object.keys(this.selectedValue).forEach((key) => {
            if (this.selectedValue[key] === null) delete this.selectedValue[key]
          })
          this.$emit('search', this.selectedValue, typeof isAutoSearch === 'boolean' ? isAutoSearch : false)
        }
      })
    },
    onSearchValue () {
      this.$refs.form.validate((valid, errMsg) => {
        if (!valid) {
          let errorMessage = ''
          Object.keys(errMsg).forEach(key => {
            errMsg[key].forEach(errObj => {
              errorMessage += errObj.message + '</br>'
            })
          })
          errorMessage = errorMessage.substr(0, errorMessage.lastIndexOf('</br>') - 1)
          console.log(errorMessage)
          this.$alert(errorMessage, '', {
            type: 'warning',
            dangerouslyUseHTMLString: true,
            callback: action => {}
          }, () => {})
        } else {
          this.$emit('onSearchValue', this.selectedValue)
        }
      })
    },
    onClear () { // 清除篩選條件
      this.selectedValue = {}
      this.filterForm.forEach(f => {
        if (f.type === 'checkbox') {
          this.$set(this.selectedValue, f.name, [])
        }
      })
      this.initForm()
      document.getElementById('clearButton').blur()
      this.$emit('clear')
    },
    change (index, value) {
      if (this.filterForm[index].key === 'tagSelect') {
        const householdFilter = this.filterForm.find((item) => { return item.type === 'house' })
        if (householdFilter) delete this.selectedValue[householdFilter.name]
      }
      this.$emit('change', index, value, this.selectedValue)
    },
    onClickBtn (content) { // 點擊戶別選擇
      this.$emit('button', content)
    },
    selectedHousehold (content) { // 已選擇戶別
      const tagSelect = this.filterForm.find((item) => { return item.key === 'tagSelect' })
      if (tagSelect) delete this.selectedValue[tagSelect.name]
      this.selectedValue.household = content
      this.householdSwitch = false
    },
    generatePickerOptions (options) {
      if (options) {
        const returnOptions = {}
        const shortcutsOptions = []
        options.forEach((item) => {
          if (typeof item === 'string' && !!this.pickerOptions[item]) {
            const text = this.pickerOptions[item].text
            const range = this.pickerOptions[item].range
            shortcutsOptions.push({ text, onClick (picker) { picker.$emit('pick', range) } })
          } else if (typeof item === 'object' && item.name && item.value) {
            returnOptions[item.name] = item.value
          }
        })
        if (shortcutsOptions.length > 0) {
          returnOptions.shortcuts = shortcutsOptions
        }
        return returnOptions
      }
    },
    pickerIsClearable (options) {
      if (options) {
        const clearableOptions = options.find((item) => item.name === 'clearable')
        if (!clearableOptions) return true
        return clearableOptions.value
      }
      return true
    },
    timeSelect1 (fVal) {
      if (this.selectedValue[fVal.name1] >= this.selectedValue[fVal.name2]) {
        this.$message({
          message: '開始時間不得大於結束時間',
          type: 'warning'
        })
      }
    },
    timeSelect2 (fVal) {
      if (this.selectedValue[fVal.name2] <= this.selectedValue[fVal.name1]) {
        this.$message({
          message: '結束時間不得小於開始時間',
          type: 'warning'
        })
      }
    },
    changeSelect (fVal, val) {
      if (fVal.callback) {
        fVal.callback(val)
      }
    },
    readerGetCode (name) {
      if (!this.selectedValue[name]) this.$set(this.selectedValue, name, '')
      this.$refs.readNFCBarcode.getCode((code) => {
        this.selectedValue[name] = code
        this.$refs.readNFCBarcode.close()
      }, 'postal')
    },
    onDateTypeChange (name) {
      const today = new Date()
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
      this.selectedValue[name + 'Date'] = [firstDayOfMonth, today]
    },
    onDateTypeChange2 (radioType, name) {
      const dayOfDate = dayjs().get('day') // 取得今天是星期幾
      let targetWeekDate = dayjs().format('YYYY-MM-DD')
      /**
       * 如果今天是週日，則取得下一天
       * 1. 因應 main.js 中設定週一為每週的第一天
       */
      if (dayOfDate === 0) {
        targetWeekDate = dayjs().add(1, 'day').format('YYYY-MM-DD')
      }
      // 取得當月第一天
      const startMonth = dayjs().startOf('month')
      switch (radioType) {
      case 1: // 單週
        this.selectedValue[name + 'Date'] = targetWeekDate
        break
      case 2: // 單月
        this.selectedValue[name + 'Date'] = startMonth.format('YYYY-MM-DD')
        break
      }
    },
    setDisabledDate (date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      if (!this.firstSelectDate) {
        return date > today
      }
      const { minDate, maxDate } = this.firstSelectDate

      if (minDate && !maxDate) {
        const startDate = new Date(minDate)

        const previousDate = new Date(startDate)
        previousDate.setDate(previousDate.getDate() - 89)
        const nextDate = new Date(startDate)
        nextDate.setDate(nextDate.getDate() + 89)


        return date < previousDate || date > nextDate || date > today
      }
      return date > today
    },
    setDisabledWeek (date) {
      // 超過當週週六的日期都不能選
      return dayjs(date).format('YYYY-MM-DD') > dayjs().day(6).format('YYYY-MM-DD')
    },
    setDisabledMonth (date) {
      const today = new Date()

      if (!this.firstSelectDate) {
        return (
          date.getFullYear() > today.getFullYear() ||
          (date.getFullYear() === today.getFullYear() && date.getMonth() > today.getMonth())
        )
      }
      const { minDate, maxDate } = this.firstSelectDate
      if (minDate && !maxDate) {
        const currentMonth = minDate.getMonth()
        const currentYear = minDate.getFullYear()
        const targetMonth = date.getMonth()
        const targetYear = date.getFullYear()

        const monthDifference =
          (targetYear - currentYear) * 12 + (targetMonth - currentMonth)

        return monthDifference < -2 || monthDifference > 2 || date > today
      }
      return (
        date.getFullYear() > today.getFullYear() ||
        (date.getFullYear() === today.getFullYear() && date.getMonth() > today.getMonth())
      )
    }
  }
}
</script>
<style lang="sass" scoped>
::v-deep .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label
  position: relative
  &:before
    position: absolute
    left: -8px
::v-deep .el-form-item.is-success .el-input__inner
  border-color: $borderDark1
.filter_frame
  background-color: $bgDark3
  ::v-deep .el-form
    display: flex
    flex-direction: row
    flex-wrap: wrap
    padding: 15px 15px 0
    &-item
      text-align: left
      white-space: nowrap
      margin-bottom: 10px
      &:nth-child(3n-2)
        flex-basis: 32%
      &:nth-child(3n-1)
        flex-basis: 32%
      &:nth-child(3n)
        flex-basis: 32%
      &__content
        width: calc(100% - 100px)
        text-align: left
        .el-date-editor
          width: 100%
        .el-select
          display: block
      &__label
        font-size: map-get($fontSize,small)
        color: $mainFontColor
      .el-button
        white-space: initial
    .radioAndDate
      width: 100%
      .el-form-item__content
        width: 100%
        height: 60px
        display: block
        padding-right: 0px
        .el-radio-group
          display: block
        .el-date-editor
          display: block
          position: relative
          margin-top: 10px
          padding: 3px 8px
          .el-range-input
            width: 80px
          .el-range-input,.el-range-separator
            display: inline-block
            position: relative
            top: -3px
            left: auto
          .el-input__icon
            display: inline-block
            width: 20px
    .month
      width: 100%
      .el-form-item__content
        width: 100%
      .el-input__inner
        text-align: center
    .el-date-editor--time-select
      width: 120px
    .timeSelect
      margin: 0 10px
  .titleBar
    text-align: left
    font-weight: bold
    color: $mainFontColor
    padding: 15px 15px 0
  .controls
    display: flex
    justify-content: flex-end
    padding: 0 12px 15px
  .item-content--center
    ::v-deep .el-form-item__content
      width: auto
  .item-content--wider
    flex-basis: calc(32% + 80px) !important
  .barcode-input
    width: calc(100% - 150px)
    margin-right: 10px
</style>
